import axios from 'axios';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.scss';
import { Box, Button, Typography } from '@mui/material';
import { UserContext } from '../../contexts/UserContext';

const Logout = () => {
  const { logout } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    localStorage.removeItem('isha_token');
    navigate('/');
  }

  useEffect(() => {
    handleLogout();
  }, []);

  return (
    <div>
      <h1>Logout</h1>
      <Box className="StyledContent">
        <Box className="StyledButtonContainer">
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">Logout</Typography>
            <Typography variant="body1" className="StyledCardText">Click the button if it does not automatically log out out.</Typography>
            <Button className="CustomButton" variant="contained" color="primary" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Logout;
